import React from 'react';
import NewsCard from './NewsCard';
import './NewsGrid.css';

const NewsGrid = () => {
  const articles = [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop',
      alt: 'Stock Market Charts',
      category: 'Markets',
      categoryUrl: '/markets',
      title: "Markets in Trump's New World Order Rally Even After Attacks",
      articleUrl: '/article/markets-trump-rally',
      time: '2 hours ago',
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=250&fit=crop',
      alt: 'AI Technology Concept',
      category: 'Technology',
      categoryUrl: '/tech',
      title: 'AMD Unveils New AI Chip for Corporate Data Centers',
      articleUrl: '/article/amd-ai-chip',
      time: '4 hours ago',
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=400&h=250&fit=crop',
      alt: 'Bitcoin Cryptocurrency',
      category: 'Crypto',
      categoryUrl: '/article/bitcoin-holds-100k',
      title: 'Bitcoin Options Traders Eye $100,000 Following Rally',
      articleUrl: '/article/bitcoin-options-traders',
      time: '6 hours ago',
    },
    {
      id: 4,
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=250&fit=crop',
      alt: 'Oil Industry Infrastructure',
      category: 'Energy',
      categoryUrl: '/article/renewable-energy-investment-high',
      title: 'Global Oil Markets Adjust to Shifting Supply Dynamics',
      articleUrl: '/article/renewable-energy-investment-high',
      time: '8 hours ago',
    },
    {
      id: 5,
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=250&fit=crop',
      alt: 'Business Meeting Discussion',
      category: 'Deals',
      categoryUrl: '/article/buyout-firm-software-deal',
      title: 'Buyout Firm Nears Deal to Take Software Company Private',
      articleUrl: '/article/buyout-firm-software-deal',
      time: '10 hours ago',
    },
    {
      id: 6,
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=250&fit=crop',
      alt: 'Modern City Skyline',
      category: 'Property',
      categoryUrl: '/article/asian-property-resilience',
      title: 'Asian Property Markets Show Resilience',
      articleUrl: '/article/asian-property-resilience',
      time: '12 hours ago',
    },
  ];

  return (
    <section className="news-grid">
      <div className="grid">
        {articles.map(article => (
          <NewsCard key={article.id} {...article} />
        ))}
      </div>
    </section>
  );
};

export default NewsGrid;
